import styled from 'styled-components';

/**
 * Styled component for H3 headers
 */
export const H3 = styled.h3`
	margin: 16px;
	margin-bottom: 0;
`;
